/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Wc_Tut_Keys_TabInputs */

const en_wc_tut_keys_tab = /** @type {(inputs: Wc_Tut_Keys_TabInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Demote / promote a list item`)
};

/**
* | output |
* | --- |
* | "Demote / promote a list item" |
*
* @param {Wc_Tut_Keys_TabInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const wc_tut_keys_tab = /** @type {((inputs?: Wc_Tut_Keys_TabInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Wc_Tut_Keys_TabInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_wc_tut_keys_tab(inputs)
});
export { wc_tut_keys_tab as "wc.tut.keys.tab" }